<div class="icons">
    @if (arbetsorderStatusIcons.detailsIconVisible) {
    <i class="far fa-sm fa-handshake details-icon margin-to-icons" aria-hidden="true">
        <span class="font-brand">{{ arbetsorderStatusIcons.affarsform }}</span>
    </i>
    }
    @if (arbetsorderStatusIcons.terminalVisible) {
    <i class="far fa-sm fa-warehouse-full details-icon margin-to-icons" aria-hidden="true">
    </i>
    }
    @if (arbetsorderStatusIcons.importVisible) {
    <i class="far fa-sm fa-ship details-icon margin-to-icons" aria-hidden="true">
    </i>
    }
    @if (arbetsorderStatusIcons.ckVisible) {
    <i class="text-icon details-icon margin-to-icons" aria-hidden="true"><b class="text-icon-text">CK</b></i>
    }
    @if (!arbetsorderStatusIcons.maskinIconVisible) {
    <i class="table-cell-icon-hidden"></i>
    }
    @if (shouldShowRestriktionIcon()) {
        <i [ngClass]="getRestriktionIcon()" class="details-icon margin-to-icons" aria-hidden="true"></i>
    }
    @if (arbetsorderStatusIcons.maskinIconVisible) {
    <i class="ri ri-fw ri-maskinlag details-icon" aria-hidden="true"
        [ngClass]="{'table-cell-icon-selected': arbetsorderStatusIcons.maskinikon}"></i>
    }
    @if (arbetsorderStatusIcons.produktsattIconVisible) {
    <i class="fas fa-fw fa-tree details-icon" aria-hidden="true"
        [ngClass]="{'table-cell-icon-selected': arbetsorderStatusIcons.produktsatt}"></i>
    }
    @if (arbetsorderStatusIcons.destineradIconVisible) {
    <i class="fas fa-fw fa-industry details-icon" aria-hidden="true"
        [ngClass]="{'table-cell-icon-selected': arbetsorderStatusIcons.destinerad}"></i>
    }
    @if (arbetsorderStatusIcons.koordinaterVerifieradeIconVisible) {
    <i class="fas fa-fw fa-map-marker-alt details-icon" aria-hidden="true"
        [ngClass]="{'table-cell-icon-selected': arbetsorderStatusIcons.koordinaterVerifierade}"></i>
    }
    @if (arbetsorderStatusIcons.valsStatusIconVisible) {
    <i class="fas fa-fw fa-paper-plane details-icon" aria-hidden="true"
        [ngClass]="getIkonKlassValssynkroniseringsstatus()"></i>
    }
    @if (arbetsorderStatusIcons.voStatusIconVisible && !arbetsorderStatusIcons.viol3 && (showSpinner$ | async) ===
    false) {
    <i class="fas fa-fw fa-file details-icon" aria-hidden="true" [ngClass]="(virkeskopIcon$ | async)"></i>
    }
    @if (arbetsorderStatusIcons.voStatusIconVisible && (showSpinner$ | async)) {
    <div class="spinner-box"><i class="fas fa-fw fa-circle-notch fa-spin spinner-style"></i></div>
    }
    @if (arbetsorderStatusIcons.viol3 && (showViol3Spinner$ | async) === false) {
    <i class="fas fa-fw fa-file-alt details-icon" aria-hidden="true" [ngClass]="(viol3Icon$ | async)"></i>
    }
    @if (arbetsorderStatusIcons.viol3 && (showViol3Spinner$ | async)) {
    <div class="spinner-box"><i class="fas fa-fw fa-circle-notch fa-spin spinner-style"></i></div>
    }
</div>